import { useState, useCallback } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

var WORDS = 'lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum'.split(' ');

function genWords(n) { var r = []; for (var i = 0; i < n; i++) { r.push(WORDS[Math.floor(Math.random() * WORDS.length)]); } r[0] = r[0].charAt(0).toUpperCase() + r[0].slice(1); return r.join(' ') + '.'; }
function genSentences(n) { var r = []; for (var i = 0; i < n; i++) { r.push(genWords(8 + Math.floor(Math.random() * 12))); } return r.join(' '); }
function genParagraphs(n) { var r = []; for (var i = 0; i < n; i++) { r.push(genSentences(3 + Math.floor(Math.random() * 4))); } return r.join('\n\n'); }

function LoremGenerator() {
  const [mode, setMode] = useState('paragraphs');
  const [count, setCount] = useState(3);
  const [output, setOutput] = useState('');
  const [copied, setCopied] = useState(false);

  var generate = useCallback(function () {
    var n = Math.max(1, Math.min(100, count));
    if (mode === 'paragraphs') setOutput(genParagraphs(n));
    else if (mode === 'sentences') setOutput(genSentences(n));
    else setOutput(genWords(n));
  }, [mode, count]);

  var copy = useCallback(function () {
    if (!output) return;
    navigator.clipboard.writeText(output).then(function () {
      setCopied(true); setTimeout(function () { setCopied(false); }, 2000);
    });
  }, [output]);

  return (
    <div className="page-prettifier">
      <SEO title="Lorem Ipsum Generator - Free Placeholder Text" description="Generate lorem ipsum placeholder text for designs, mockups, and prototypes. Choose paragraphs, sentences, or words." path="/lorem-generator" />
      <div className="container">
        <div className="tool-header">
          <h1>Lorem Ipsum Generator</h1>
          <p>Generate placeholder text for your designs, documents, or mockups.</p>
        </div>
        <AdUnit />
        <div className="toolbar">
          <div className="toolbar-left">
            <select value={mode} onChange={function (e) { setMode(e.target.value); }} className="indent-select" aria-label="Generation mode">
              <option value="paragraphs">Paragraphs</option>
              <option value="sentences">Sentences</option>
              <option value="words">Words</option>
            </select>
            <input type="number" min="1" max="100" value={count} onChange={function (e) { setCount(parseInt(e.target.value) || 1); }} className="indent-select" style={{ width: '70px' }} aria-label="Count" />
          </div>
          <div className="toolbar-right">
            <button onClick={generate} className="btn btn-primary" type="button">Generate</button>
            <button onClick={copy} className="btn btn-accent" type="button" disabled={!output}>{copied ? '✓ Copied' : 'Copy'}</button>
            <button onClick={function () { setOutput(''); }} className="btn btn-secondary" type="button">Clear</button>
          </div>
        </div>
        <div className="editor-pane" style={{ marginTop: '1rem' }}>
          <div className="pane-header"><span>Generated Text</span><span className="char-count">{output.length} chars</span></div>
          <textarea className="editor-textarea output-textarea" value={output} readOnly placeholder="Click Generate to create placeholder text..." spellCheck={false} aria-label="Generated text" style={{ minHeight: '300px' }} />
        </div>
        <section className="tool-guide">
          <h2>What is Lorem Ipsum?</h2>
          <p>Lorem Ipsum is placeholder text used in design and publishing since the 1500s. Designers use it to fill layouts before the real content is ready. It helps you focus on the visual design without getting distracted by readable text. This tool generates random lorem ipsum text that you can copy and paste into any project.</p>
        </section>
      </div>
    </div>
  );
}

export default LoremGenerator;
